/* Conditional Import of DateTime Polyfill for IE11
   provided by https://formatjs.io/docs/polyfills/intl-datetimeformat/
*/

export const convertTimeString = (timeString, locale) => {
  const localeTimeStringConfig = {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'America/Toronto',
  };

  try {
    // eslint-disable-next-line
    const date = new Date(timeString.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2'));
    return date.toLocaleTimeString(`${locale}-CA`, localeTimeStringConfig);
  } catch {
    return '';
  }
};

export const convertTimeToWeekday = (timeString, locale) => {
  try {
    // eslint-disable-next-line
    const date = new Date(timeString.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2'));
    return date.toLocaleDateString(`${locale}-CA`, { weekday: 'long' });
  } catch {
    return '';
  }
};

export const convertClosedWeekday = (nameOfDay, locale) => {
  try {
    let days: Map<string, string>;
    if (locale === 'en') {
      days = new Map([
        ['Mon', 'Monday'],
        ['Tue', 'Tuesday'],
        ['Wed', 'Wednesday'],
        ['Thu', 'Thursday'],
        ['Fri', 'Friiday'],
        ['Sat', 'Saturday'],
        ['Sun', 'Sunday'],
      ]);
    } else {
      days = new Map([
        ['Lun', 'lundi'],
        ['Mar', 'mardi'],
        ['Mer', 'mercredi'],
        ['Jeu', 'jeudi'],
        ['Ven', 'vendredi'],
        ['Sam', 'samedi'],
        ['Dim', 'dimanche'],
      ]);
    }
    const getDay = days.get(nameOfDay);
    return getDay;
  } catch {
    return '';
  }
};

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
};

export const magicStrings = {
  storeListingTitleOpen: (locale) => (locale === 'en' ? 'Open' : 'Ouvrir'),
  storeListingTitleClosed: (locale) => locale === 'en' ? 'Opens at' : 'Ouvre à',
  storeListingTitleOpens: (locale) => (locale === 'en' ? 'opens' : 'ouvre'),
  storeListingTitleCloses: (locale) => locale === 'en' ? 'closes' : 'se ferme',
  storeListingTitleClosedAllDay: (locale) => locale === 'en' ? 'Closed' : 'Fermé',
  getDirectionsLabel: (locale) => locale === 'en' ? 'Get directions' : "Obtenir l'itinéraire",
  getPlaceHolder: (locale) => locale === 'en'
    ? 'Please enter location'
    : 'Adresse, ville, province ou code postal',
  getStoreSelectorTitle: (locale) => locale === 'en' ? 'Change Store' : 'Changer de magasin',
  selected: (locale) => (locale === 'en' ? 'Selected' : 'Choisie'),
  selectThisStore: (locale) => locale === 'en' ? 'Select this store' : 'Sélectionnez ce magasin',
  selectStore: (locale) => locale === 'en' ? 'Select a store' : 'Sélectionnez un magasin',
  myStore: (locale) => (locale === 'en' ? 'My store' : 'Mon magasin'),
  TMS: (locale) => (locale === 'en' ? 'The Mobile Shop' : 'La Boutique Mobile'),
  close: (locale) => (locale === 'en' ? 'Close' : 'Fermer'),
  appointmentButtonLabel: (locale) => locale === 'en'
    ? 'Book an in-store appointment'
    : 'Prendre rendez-vous en magasin',
    
};

// * Checks if the current time falls between the Stores opening time and closing time. If it does, it is open. If it does not, it is closed
export const getStoreStatus = (openingTime, closingTime) => {
  try {
    // eslint-disable-next-line
    const OT = new Date(openingTime.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2'));
    // eslint-disable-next-line
    const CT = new Date(closingTime.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2'));
    const now = new Date();
    // * Check if the store is currently open
    const isOpen = now > OT && now < CT;
    return isOpen;
  } catch {
    return '';
  }
};

// * StoreHours is presorted, so the first index is always the current Day. Therefore we ignore the store at index[0], and return the first upcoming day that isnt closed
const determineNextOpenDate = (storeHours) => {
  const nextOpeningDay = storeHours.find(
    (store, index) => index !== 0 && !store.closed,
  );
  return nextOpeningDay;
};

// * This is called when the current time doesnt fall between the store's hours. It determines if the current time is less then the opening time. If the current time is less then the opening time, then the store is still set to open, and we return the opening time. If the current time is greater, we know the store is closed, as this func only gets called when the current time isnt between the opening and closing time. This means that we know the store is closed for the day and must determine the next opening time
export const getNextOpeningTime = (allStoreHours, openingTime, locale) => {
  try {
    // eslint-disable-next-line
    const OT = new Date(openingTime.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2'));
    const now = new Date();
    const willOpen = now < OT && !allStoreHours[0].closed;
    const nextOpeningDate = determineNextOpenDate(allStoreHours);
    return willOpen
      ? convertTimeString(openingTime, locale)
      : convertTimeString(nextOpeningDate.openingTime, locale);
  } catch {
    return '';
  }
};
